<template>
  <Toast />
  <component :is="useLayout"></component>
</template>

<script>
import { useRoute } from "vue-router";
import { computed, onMounted } from "vue";
import AccountLayout from "./layout/AccountLayout.vue";
import GeneralLayout from "./layout/GeneralLayout.vue";

export default {
  components: {
    AccountLayout,
    GeneralLayout,
  },

  setup() {
    const route = useRoute();

    onMounted(() => {
      console.log("Meta Cheker");
      console.log(route.meta);
    });

    const useLayout = computed(() => {
      console.log(`${route.meta.layout}Layout`);
      return `${route.meta.layout}Layout`;
    });

    return { useLayout };
  },
};
</script>
